import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type MobileVideoModalMode = 'hidden' | 'collapsed' | 'compact' | 'expanded' | 'fullscreen';

export type VideoCallCredentialsSliceState = {
  is_visible: boolean;
  vc_case_id: string;
  uploadFileMethod: (file: File) => Promise<void>;
  mobileModalMode: MobileVideoModalMode;
  mobileModalHeight: number;
  hasJoined: boolean;
};

const initialState: VideoCallCredentialsSliceState = {
  is_visible: false,
  vc_case_id: '',
  uploadFileMethod: () => Promise.resolve(),
  mobileModalMode: 'expanded',
  mobileModalHeight: 0,
  hasJoined: false,
};

export const videoCallCredentialsSlice = createSlice({
  name: 'videoCallCredentials',
  initialState,
  reducers: {
    setIsVisible(state, action: PayloadAction<boolean>) {
      state.is_visible = action.payload;

      if (!action.payload) {
        state.mobileModalMode = 'expanded';
        state.mobileModalHeight = 0;
        state.hasJoined = false;
      }
    },

    setVCCaseId(state, action: PayloadAction<string>) {
      state.vc_case_id = action.payload;
    },

    setUploadFileMethod(state, action: PayloadAction<(file: File) => Promise<void>>) {
      state.uploadFileMethod = action.payload;
    },

    setMobileModalMode(state, action: PayloadAction<MobileVideoModalMode>) {
      state.mobileModalMode = action.payload;
    },

    setMobileModalHeight(state, action: PayloadAction<number>) {
      state.mobileModalHeight = action.payload;
    },

    setHasJoined(state, action: PayloadAction<boolean>) {
      state.hasJoined = action.payload;
    },

    resetMobileVideoModalState(state) {
      state.mobileModalMode = 'hidden';
      state.mobileModalHeight = 0;
      state.hasJoined = false;
    },

    resetVideoCallCredentialsState(state) {
      state.is_visible = false;
      state.vc_case_id = '';
      state.uploadFileMethod = () => Promise.resolve();
      state.mobileModalMode = 'expanded';
      state.mobileModalHeight = 0;
      state.hasJoined = false;
    },
  },
});

export const {
  setIsVisible,
  setVCCaseId,
  setUploadFileMethod,
  setMobileModalMode,
  setMobileModalHeight,
  setHasJoined,
  resetMobileVideoModalState,
  resetVideoCallCredentialsState,
} = videoCallCredentialsSlice.actions;

export default videoCallCredentialsSlice.reducer;